import React from "react";
import { Helmet } from "react-helmet-async";
let defaultOgImage = "https://contentgenerator.io/ogImage1200.webp";

// Import hero images for preloading
import heroImage from "../../assets/img/heroimage.webp";
import mobileHeroImage from "../../assets/img/mobileHeroImage.webp";

export default function CustomMeta(props) {
  const { title, description, url, ogImage } = props;

  let ogImageUsed = ogImage ? ogImage : defaultOgImage;

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={url} />
      <meta name="description" content={description} />

      {/* <!-- Twitter Card data --> */}
      <meta name="twitter:card" content="summary_large_image"></meta>
      <meta name="twitter:creator" content="@OliverBoyers" />
      <meta name="twitter:site" content="@OliverBoyers" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${ogImageUsed}`} />
      <meta name="twitter:url" content={url} />

      {/* <!-- Open Graph data --> */}
      <meta property="og:title" content={`${title}`} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImageUsed} />
      <meta property="og:description" content={description} />
    </Helmet>
  );
}
